import {Button, Divider, Grid, Paper, TextField} from "@mui/material";
import {logoBusmen} from "./img/imgContent";
import {useContext, useState} from "react";
import {AuthContext} from "./Global/AuthContext";

// ALERT
import Swal from "sweetalert2";
import {encryptText, promiseServer} from "./Global/FunctionToConnection";


const VALUES_USER = {
    user: "",
    pwd: "",
}

export function LogUserComponent (){

    const { handlingLogInUser, isMobile } = useContext(AuthContext);

    const [valuesUser, setValuesUser] = useState(VALUES_USER);

    const handlingLogIn = async () => {
        if (valuesUser.user === "") {
            await Swal.fire(
                'Campo vació',
                `El campo de usuario no puede ir vacío.`,
                'warning'
            );
            return;
        }
        if (valuesUser.pwd === "") {
            await Swal.fire(
                'Campo vació',
                `El campo de la contraseña no puede ir vacío.`,
                'warning'
            );
            return;
        }
        let params = {
            id_usuario: valuesUser.user,
            contrasena: valuesUser.pwd
        }
        let response = await promiseServer("logIn-preodt", params);

        if(response.respuesta === "exito"){

            await Swal.fire({
                title: 'Entrando..',
                text: `Verificando los datos..`,
                icon: 'success',
                showConfirmButton: false,
                timer: 2000, // Tiempo en milisegundos (en este caso, 3 segundos)
                timerProgressBar: true, // Muestra una barra de progreso que disminuye durante el tiempo del temporizador
            });
            let dataUserResponse = {
                id: response.datos[0].id_usuario,
                pwd: encryptText(valuesUser.pwd),
                permiso: response.datos[0].tipo_usuario
            };
            handlingLogInUser(dataUserResponse);

        }else{
            await Swal.fire(
                'Algo salió mal',
                response.mensaje,
                'warning'
            );
        }
    }

    return(
        <Grid container
              direction="row"
              justifyContent="center"
              alignItems="center" style={{height: "95vh", backgroundColor: "rgb(33, 150, 243)"}}>
            <Grid item xs={isMobile? 12 : 6} container
                  direction="row"
                  justifyContent="center"
                  alignItems="center">
                <img style={{width: "100%"}} src={logoBusmen.default} alt="logo busmen"/>
            </Grid>
            <Grid item xs={isMobile? 12 : 6} container
                  direction="row"
                  justifyContent="center"
                  alignItems="center">
                <Paper elevation={12} style={{width: "100%", padding: "1vh"}}>

                    <TextField value={valuesUser.user} autoFocus fullWidth type="text" label="Usuario"
                               onChange={(dataInsert)=> setValuesUser((oldData)=>
                                   ({...oldData, user: dataInsert.target.value}))
                               }
                    />

                    <Divider style={{margin: "2vh"}}/>

                    <TextField value={valuesUser.pwd} fullWidth type="password" label="Contraseña"
                               onChange={(dataInsert)=> setValuesUser((oldData)=>
                                   ({...oldData, pwd: dataInsert.target.value}))
                               }
                    />

                    <Divider style={{margin: "2vh"}}/>

                    <Button fullWidth variant="contained" onClick={handlingLogIn}>Ingresar</Button>

                </Paper>
            </Grid>
        </Grid>
    );
}